const gifById = {
  '_id': '5da23754845fd2cb76d59ee7',
  'gifLink': 'https://media.tenor.com/images/4393cee845d8464670817e40b0601e3b/tenor.gif'
};

export default gifById;
